/**
 * Homepage Redesign 2026 - JavaScript
 * LKWvermietung.de - Modern Interactions
 */
(function() {
  'use strict';

  // ===========================================
  // 1. Scroll Reveal Animation
  // ===========================================
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: Show all elements immediately
      document.querySelectorAll('.reveal').forEach(function(el) {
        el.classList.add('active');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ===========================================
  // 2. Offer Carousel
  // ===========================================
  function initOfferCarousel() {
    var carousel = document.querySelector('.offer-carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.carousel-slide');
    var indicators = carousel.querySelectorAll('.carousel-indicator');
    var prevBtn = carousel.querySelector('.carousel-prev');
    var nextBtn = carousel.querySelector('.carousel-next');

    if (slides.length === 0) return;

    var currentIndex = 0;
    var isPaused = false;
    var timer = null;

    function showSlide(index) {
      // Wrap around
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      currentIndex = index;

      // Update slides
      slides.forEach(function(slide, i) {
        if (i === currentIndex) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });

      // Update indicators
      indicators.forEach(function(indicator, i) {
        if (i === currentIndex) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
    }

    function nextSlide() {
      showSlide(currentIndex + 1);
    }

    function prevSlide() {
      showSlide(currentIndex - 1);
    }

    function startAutoPlay() {
      if (timer) clearInterval(timer);
      timer = setInterval(function() {
        if (!isPaused) {
          nextSlide();
        }
      }, 5000);
    }

    function stopAutoPlay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Event Listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        prevSlide();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        nextSlide();
      });
    }

    // Pause on hover
    carousel.addEventListener('mouseenter', function() {
      isPaused = true;
    });

    carousel.addEventListener('mouseleave', function() {
      isPaused = false;
    });

    // Click on indicators
    indicators.forEach(function(indicator, i) {
      indicator.addEventListener('click', function() {
        showSlide(i);
      });
    });

    // Touch/Swipe support
    var touchStartX = 0;
    var touchEndX = 0;

    carousel.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    carousel.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    }

    // Initialize
    showSlide(0);
    startAutoPlay();
  }

  // ===========================================
  // 3. FAQ Accordion
  // ===========================================
  function initAccordion() {
    var accordionGroups = document.querySelectorAll('.faq-accordion-group, .seo-grid, .booking-faq-container');

    accordionGroups.forEach(function(group) {
      var toggles = group.querySelectorAll('.faq-accordion-toggle, .seo-accordion-toggle, .booking-faq-toggle');

      toggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();

          var item = this.closest('.faq-accordion-item, .seo-accordion-item, .booking-faq-item');
          if (!item) return;

          var isOpen = item.classList.contains('open');

          // Close all other items in this group (single-open mode)
          var allItems = group.querySelectorAll('.faq-accordion-item, .seo-accordion-item, .booking-faq-item');
          allItems.forEach(function(otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('open');
            }
          });

          // Toggle current item
          if (isOpen) {
            item.classList.remove('open');
          } else {
            item.classList.add('open');
          }
        });
      });
    });
  }

  // ===========================================
  // 4. Sticky CTA Button
  // ===========================================
  function initStickyCta() {
    var stickyCta = document.querySelector('.sticky-cta');
    if (!stickyCta) return;

    var threshold = 500;
    var ticking = false;

    function updateStickyCta() {
      if (window.scrollY > threshold) {
        stickyCta.classList.add('visible');
      } else {
        stickyCta.classList.remove('visible');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyCta);
        ticking = true;
      }
    }, { passive: true });

    // Initial check
    updateStickyCta();
  }

  // ===========================================
  // 5. Tabbed Content
  // ===========================================
  function initTabbedContent() {
    var tabContainers = document.querySelectorAll('.tabs-container');

    tabContainers.forEach(function(container) {
      var tabs = container.querySelectorAll('.tab-btn');
      var panels = container.querySelectorAll('.tab-panel');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          e.preventDefault();

          var targetId = this.getAttribute('data-tab');

          // Update tabs
          tabs.forEach(function(t) {
            t.classList.remove('active');
          });
          this.classList.add('active');

          // Update panels
          panels.forEach(function(panel) {
            if (panel.id === targetId) {
              panel.classList.add('active');
            } else {
              panel.classList.remove('active');
            }
          });
        });
      });
    });
  }

  // ===========================================
  // 6. Smooth Scroll for Anchor Links
  // ===========================================
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href === '#' || href === '#0') return;

        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ===========================================
  // 7. Initialize Lucide Icons
  // ===========================================
  function initLucideIcons() {
    if (typeof lucide !== 'undefined' && lucide.createIcons) {
      lucide.createIcons();
    }
  }

  // ===========================================
  // 8. Header Login Modals
  // ===========================================
  function initHeaderLoginModals() {
    var sidebar = document.querySelector('.frontpage-header-redesign .sidebar');
    var loginView = document.querySelector('.frontpage-header-redesign .views.login-view');
    var vermieterView = document.querySelector('.frontpage-header-redesign .views.vermieter-view');

    if (!sidebar) return;

    // Funktion zum Schließen aller Modals
    function closeAllModals() {
      sidebar.classList.remove('modal-open');
      if (loginView) loginView.classList.remove('modal-visible');
      if (vermieterView) vermieterView.classList.remove('modal-visible');
      document.body.style.overflow = '';
    }

    // Funktion zum Öffnen des Login-Modals
    function openLoginModal() {
      // Inline-Styles von altem jQuery-Code entfernen
      if (loginView) {
        loginView.style.display = '';
        loginView.classList.add('modal-visible');
      }
      if (vermieterView) {
        vermieterView.classList.remove('modal-visible');
      }
      sidebar.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
    }

    // Funktion zum Öffnen des Vermieter-Modals
    function openVermieterModal() {
      // Inline-Styles von altem jQuery-Code entfernen
      if (vermieterView) {
        vermieterView.style.display = '';
        vermieterView.classList.add('modal-visible');
      }
      if (loginView) {
        loginView.classList.remove('modal-visible');
      }
      sidebar.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
    }

    // "Reservierung verwalten" Button im Header
    var headerMLogin = document.getElementById('header-m-login');
    if (headerMLogin) {
      headerMLogin.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openLoginModal();
      });
    }

    // "Vermieter-Login" Button im Header
    var headerVLogin = document.getElementById('header-v-login');
    if (headerVLogin) {
      headerVLogin.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openVermieterModal();
      });
    }

    // Schließen-Buttons in den Modals - stopImmediatePropagation verhindert alte jQuery-Handler
    document.querySelectorAll('.frontpage-header-redesign .btn-close').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeAllModals();
      }, true); // capture phase für Priorität
    });

    // Tab-Umschaltung: Globaler document-level Handler mit capture phase
    // um ALLE Events vor jQuery abzufangen
    document.addEventListener('click', function(e) {
      // Prüfe ob das geklickte Element ein Tab-Link in unseren Modals ist
      var tabLink = e.target.closest('.frontpage-header-redesign .sidebar .views .nav-tabs a');
      if (!tabLink) return;

      // Stoppe ALLES - jQuery bekommt dieses Event nicht
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Tab manuell aktivieren
      var target = tabLink.getAttribute('data-target') || tabLink.getAttribute('href');
      if (target && target.startsWith('#')) {
        // Finde das übergeordnete views Element
        var viewsEl = tabLink.closest('.views');

        // Alle Tabs deaktivieren
        var tabList = tabLink.closest('.nav-tabs');
        if (tabList) {
          tabList.querySelectorAll('li').forEach(function(li) {
            li.classList.remove('active');
          });
          tabList.querySelectorAll('a').forEach(function(a) {
            a.setAttribute('aria-expanded', 'false');
          });
        }

        // Aktuellen Tab aktivieren
        var li = tabLink.closest('li');
        if (li) li.classList.add('active');
        tabLink.setAttribute('aria-expanded', 'true');

        // Tab-Panels umschalten
        var tabContent = viewsEl ? viewsEl.querySelector('.tab-content') : null;
        if (!tabContent && tabList) {
          tabContent = tabList.parentElement.querySelector('.tab-content');
        }

        if (tabContent) {
          tabContent.querySelectorAll('.tab-pane').forEach(function(pane) {
            pane.classList.remove('active');
          });
          var targetPane = tabContent.querySelector(target);
          if (targetPane) {
            targetPane.classList.add('active');
          }
        }
      }

      return false;
    }, true); // capture phase - MUSS vor jQuery greifen

    // Klicks innerhalb der Modal-Views sollen nicht propagieren (verhindert $('html').click())
    // AUSNAHME: Close-Buttons, Form-Buttons und Links müssen durchgelassen werden
    document.querySelectorAll('.frontpage-header-redesign .views').forEach(function(view) {
      view.addEventListener('click', function(e) {
        // Close-Button Klicks durchlassen
        if (e.target.closest('.btn-close')) {
          return;
        }
        // Form-Buttons (Login, Weiter, etc.) durchlassen
        if (e.target.closest('button.btn-green, input[type="submit"]')) {
          return;
        }
        // Links durchlassen (z.B. "Passwort vergessen?", "Zurück zum Login", etc.)
        if (e.target.closest('a')) {
          return;
        }
        e.stopPropagation();
      }, true); // capture phase
    });

    // Klick auf Sidebar-Hintergrund schließt Modal
    sidebar.addEventListener('click', function(e) {
      if (e.target === this) {
        closeAllModals();
      }
    });

    // ESC-Taste schließt Modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAllModals();
      }
    });
  }

  // ===========================================
  // Initialize All
  // ===========================================
  function init() {
    initLucideIcons();
    initScrollReveal();
    initOfferCarousel();
    initAccordion();
    initStickyCta();
    initTabbedContent();
    initSmoothScroll();
    initHeaderLoginModals();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
